import { render, staticRenderFns } from "./pagination-type-2-component.vue?vue&type=template&id=5416c278&scoped=true&"
import script from "./pagination-type-2-component.vue?vue&type=script&lang=js&"
export * from "./pagination-type-2-component.vue?vue&type=script&lang=js&"
import style0 from "./pagination-type-2-component.vue?vue&type=style&index=0&id=5416c278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5416c278",
  null
  
)

export default component.exports